import DealIncomeLink from '../../shared/components/DealIncomeLink';
import EntityLinkButton from '../../../../shared/components/linked-entities/EntityLinkButton';
import React from 'react';
import { AssetIcon } from '../../../../shared/assets';
import { resolveDealResponsible } from '../../shared/utils/dealStaff';

function getClientResolutionHint(status) {
  if (status === 'legacy_fallback') {
    return 'Cliente da snapshot legacy';
  }

  if (status === 'missing_client_id') {
    return 'ClientId mancante';
  }

  if (status === 'unresolved_client_reference') {
    return 'ClientId non risolto nel catalogo clienti';
  }

  return '';
}

const InProgressCard = ({
  deal,
  onClick,
  onOpenClient,
  onOpenStaff,
  provided,
  snapshot,
  staff = [],
}) => {
  const clientName = deal.clientResolvedName || deal.client || 'Cliente non risolto';
  const clientResolutionHint = getClientResolutionHint(deal.clientResolutionStatus);
  const canOpenClient = Boolean(deal.clientId);
  const responsible = resolveDealResponsible(deal, staff);

  return (
    <article
      ref={provided.innerRef}
      {...provided.draggableProps}
      className={snapshot.isDragging ? 'deals-card is-dragging' : 'deals-card'}
      onClick={() => onClick(deal)}
    >
      <div className="deals-card__inner">
        <div className="deals-card__header">
          <div
            {...provided.dragHandleProps}
            className="deals-card__handle"
            aria-label="Sposta affare"
          >
            <AssetIcon name="actions.menu" size={16} />
          </div>

          <h4 className="deals-card__title">
            {deal.name}
          </h4>

          <span className={`deals-badge deals-badge--${deal.urgency}`}>
            {deal.urgency}
          </span>
        </div>

        <div className="deals-card__content">
          <EntityLinkButton
            className="deals-card__section"
            disabled={!canOpenClient}
            aria-label={`Apri cliente ${clientName}`}
            onClick={(e) => {
              if (!canOpenClient) return;
              e.stopPropagation();
              onOpenClient?.(deal.clientId, clientName);
            }}
          >
            <span className="deals-card__label">
              <AssetIcon name="nav.clients" size={16} />
              Cliente:
            </span>
            <p className={canOpenClient ? 'deals-card__value deals-card__link-text' : 'deals-card__value'}>
              {clientName}
            </p>
            {clientResolutionHint ? (
              <p className="deals-card__hint">{clientResolutionHint}</p>
            ) : null}
          </EntityLinkButton>

<DealIncomeLink deal={deal} />

          <div>
            <span className="deals-card__label">
              <AssetIcon name="nav.team" size={16} />
              Responsabile:
            </span>
            {responsible.hasLinkedStaff ? (
              <EntityLinkButton
                type="button"
                className="deals-card__person-link"
                aria-label={`Apri scheda staff di ${responsible.label}`}
                onClick={(event) => {
                  event.stopPropagation();
                  onOpenStaff?.(responsible.staffId, responsible.staffMember);
                }}
                onKeyDown={(event) => {
                  if (event.key !== 'Enter' && event.key !== ' ') return;
                  event.preventDefault();
                  event.stopPropagation();
                  onOpenStaff?.(responsible.staffId, responsible.staffMember);
                }}
              >
                {responsible.label}
              </EntityLinkButton>
            ) : (
              <p className="deals-card__value">{responsible.label}</p>
            )}
            {responsible.hasLegacyAssignee ? (
              <p className="deals-card__hint">
                Label legacy: collegamento staff non disponibile
              </p>
            ) : null}
            {responsible.hasMissingStaffReference ? (
              <p className="deals-card__hint">
                Dati staff non disponibili
              </p>
            ) : null}
          </div>
        </div>
      </div>
    </article>
  );
};

export default InProgressCard;
